import React, { useState } from 'react';
import './Style.css';
import Navbar from "./Navbar";
import Footer from "./Footer";
import {contact_hoa} from './Api.js'


function Contact() {
  const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        name: '',
        surname: '',
        email: '',
        phone_number: '',
        message: '',
        reference : 'p2p',
        flag : 'p2p'
    });

    // Step 2: Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Step 3: Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const input = {
          
           
        }
        contact_hoa(data).then(res => {
            console.log("resasset",res)
            try{
                if (res.status==='success') {
                    setData({
                    name: '',
                    surname: '',
                    email: '',
                    phone_number: '',
                    message: '',
                });
                    setLoading(false)
                    alert("Your details have been submitted successfully")
                }
                else{
                    alert("Something went wrong")
                    setLoading(false)
                }
            }catch{
                setLoading(false)
                alert("Something went wrong")
            }
        })
    };

    return (
        <>
              <Navbar />
                 <div className='Gapp'></div>
            <div className="d-flex justify-content-center align-items-center">
                <div className="contactDiv">
                    <p className="ParaText">Get in touch and let us know how we can help</p>

                    <div className="contactCard">
                        <form onSubmit={handleSubmit}>
                            <div className="row mb-3">
                                <div className="col">
                                    <label className="form-label">First Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="First name"
                                        value={data.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col">
                                    <label className="form-label">Last Name</label>
                                    <input
                                        type="text"
                                        name="surname"
                                        className="form-control"
                                        placeholder="Last name"
                                        value={data.surname}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="Enter your email"
                                    value={data.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="tel"
                                    name="phone_number"
                                    className="form-control"
                                    placeholder="Phone number"
                                    value={data.phone_number}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea
                                    name="message"
                                    className="form-control"
                                    rows="4"
                                    placeholder="Write your message"
                                    value={data.message}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            <div className="Btn">
                                <button type="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
             <Footer />
        </>
    );
}

export default Contact;